export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE'
};

export const contentfulQueryConstants = {
  brand: 'generalUsFuelBrands',
  cStoreBrand: 'generalcStoreBrands',
  classOfTrade: 'generalUsClassOfTrade',
  division: 'generalDivisions',
  generalLinkList: 'generalLinkList',
  generalListGroups: 'generalListGroups',
  externalLinks: 'External Links',
  form: 'generalForms',
  report: 'generalReports',
  helpTopic: 'generalHelpTopics',
  planogram: 'stationPortalUsPlanogram',
  stationPortalArticle: 'stationPortalUsArticle',
  stationPortalCategory: 'stationPortalUsCategory',
  stationPortalPlanogramCategory: 'stationPortalUsPlanogramCategory',
  stationPortalSubCategory: 'stationPortalUsSubCategory',
  stationPortalSubCategory2: 'stationPortalUsSubCategory2',
  region: 'generalUsRegions',
  tag: 'generalUsTags',
  contact: 'generalContacts',
  faq: 'stationPortalFaq',
  calendarEntry: 'generalUsCalendarEntry',
  articleCategories: {
    hseMomentsEN: 'HSE Moments',
    hseMomentsFR: 'Moments HSE',
    safetySecurityComplaince: 'Safety, Security and Compliance',
    carWash: 'Car Wash',
    otrDealerEN: 'OTR Dealer',
    otrDealerFR: 'Concessionnaire OTR',
    termsOfUse: 'Terms of Use'
  },
  values: {
    True: 'true',
    False: 'false'
  }
};
